/**
 * Code by Mathieu VANBESELAERE for ->
 * @copyright Copyright (c) Agence ink
 */

//// Module summary ////
// This module gathers the animations we need sitewide!

/////////////// GSAP animation modules (Uncomment required gsap library!) /////////////////
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
///////////////////////////////////////////////////////////////////////////////////////////

export const animations = () => {
    // [ANIMATION] TITLES + SUBTITLES
    // -> Allows a group title+subtitle to be animated
    // -> Title will enter from the right, the subtitle will fade down
    // -> Requires the title to be named .super-text
    // -> Will look for a .heading-md subtitle as nextSibling
    let titles = document.querySelectorAll(".super-text");

    if (titles.length) {
    // => Title animation setup
        let titleSetUp = (title) => {
            let TL_TITLES = gsap.timeline({
                scrollTrigger: {
                    trigger: title,
                    start: "top 75%",
                    markers: false
                },
            });
            TL_TITLES.to(title, {
                autoAlpha: 1,
                x: 0,
                duration: 1.5,
            });

            // Check if subtitle, hide it, and assign its animation to the timeline
            let subtitle = title.nextElementSibling && title.nextElementSibling.classList.contains("heading-md") ? title.nextElementSibling : null;
            if (subtitle) {
                gsap.set(subtitle, { autoAlpha: 0, y: "-100%" });
                TL_TITLES.to(
                    subtitle,
                    {
                        y: 0,
                        autoAlpha: 1,
                        duration: 1,
                    },
                    "<+=1"
                );
            }
        };

        // => Title animation assign
        for (let currentTitle of titles) {
            titleSetUp(currentTitle);
        }
    }

    // [ANIMATION] BORDER RADIUS ON HOVER
    // -> A smooth eased hover-animation with the borderRadius (used on project-cards)
    let radiusCard = document.querySelectorAll('[data-gsap="radius"]');

    if (radiusCard.length) {
        for (let card of radiusCard) {
            const TL_PROJECT_CARD = gsap.timeline({
                paused: true
            });
            TL_PROJECT_CARD.to(card, {
                duration: 0.2,
                ease: "power1.inOut",
                borderRadius: "28em"
            });

            // => Animation assign
            card.addEventListener("mouseover", () => {
                TL_PROJECT_CARD.play();
            });
            card.addEventListener("mouseout", () => {
                TL_PROJECT_CARD.reverse();
            });
        }
    }

    // [ANIMATION] PREV / NEXT ARTICLES
    // -> Will grow / shrink the prev-next buttons clip-paths on mouse interaction
    // -> Used on project-single && nouvelle-single
    let clips = document.querySelectorAll(".clip");
    if (clips.length > 0) {
        for (let currentClip of clips) {

            // Register 2 animations and pause them se we can separately work on their behaviors
            let reveal = gsap.to(currentClip, {
                clipPath: "circle(75%)",
                duration: 1,
                ease: "power4.out"
            });

            let hide = gsap.to(currentClip, {
                clipPath: "circle(0%)",
                duration: 0.5,
                ease: "power4.out"
            });
            // Those animations are different on Safari are it does not support clip-path animations...
            if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                // Set a new starting state for clips
                gsap.set(currentClip, {
                    clipPath: "circle(75%)",  
                    scale: .75,
                    autoAlpha: 0,
                    overflow: "hidden",
                });

                reveal = gsap.to(currentClip, {
                    scale: 1,
                    duration: .4,
                    autoAlpha: 1,
                    borderRadius: "20rem",
                    ease: "slow(0.1, 0.7, false)"
                });

                hide = gsap.to(currentClip, {
                    scale: .9,
                    autoAlpha: 0,
                    borderRadius: 0,
                    duration: 0.5,
                    ease: "power4.out"
                });
            }

            reveal.pause();
            hide.pause();

            currentClip.parentElement.addEventListener("mouseenter", () => {
                hide.pause();
                reveal.seek(0);
                reveal.play();
            });

            currentClip.parentElement.addEventListener("mouseleave", () => {
                reveal.pause();
                hide.seek(0);
                hide.play();
            });
        }
    }

    return;
};
